module.exports = __webpack_public_path__ + "img/01.543ca05c.jpg";